import React from "react";
import { MenuItem, Select } from "@mui/material";

export default function RecordedSelect({ children, value, onEdit, onChange, ...props }) {
  const options = React.Children.toArray(children);
  const isRecorded = value !== null && value !== undefined && value !== "";
  const isKnown = options.some((option) => option.props?.value === value);
  // Keep an existing literal answer visible without interpreting it as a clinical result.
  if (isRecorded && !isKnown) {
    options.push(<MenuItem key="recorded-answer" value={value}>{String(value)}</MenuItem>);
  }
  return <Select {...props} value={value ?? ""} onChange={(event, child) => {
    onEdit?.();
    onChange?.(event, child);
  }}>{options}</Select>;
}
